import './list.css'
import React,{ useEffect, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Collapse from '@mui/material/Collapse'
import { Add, Edit, Remove } from '@mui/icons-material'
import SingleValue from './single-value'
import Nested from './nested'
import filter from '../../../service/filter'
import CONSTANT from '../../../Constant/Constant'
import {Stack, Tooltip} from '@mui/material'
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import LinkIcon from '@mui/icons-material/Link';
import {IconButton} from '@mui/material'
import EditOffIcon from '@mui/icons-material/EditOff';
import moment from 'moment';
import ReplayIcon from '@mui/icons-material/Replay';
import DeleteIcon from '@mui/icons-material/Delete';
import SourceList from '../../../config/ProfileDetailsData.json'
import InputDetail from '../input/detail-input'
import SnackBarComponent from '../input/snackBar'
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0)
  },
  nested: {
    paddingLeft: theme.spacing(1)
  }
}))

// custom style for tooltip width
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
  },
});

const ListView = props => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)  
  const [sourceConfig] = useState(SourceList)
  const [openList, setOpenList] = useState(false)
  const [brickOpen, setBrickOpen] = useState(false)
  const [label, setLabel] = useState(props.label)
  const [value, setValue] = useState(props.value)
  const [updatedValue, setUpdatedValue] = useState(props.value)
  const [updatedValueFlag, setUpdatedValueFlag] = useState()
  const labelKey = Object.keys(value).sort()
  const [mode, setMode] = useState(true)
  const [error, setError] = useState(false)
  const [editMode, setEditMode] = useState (false)
  const [specialtyEditFlag, setSpecialtyEditFlag] = useState(props.strikeThrough ? props.strikeThrough : false)
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackBarMessage] = useState('')
  const [oldEffectiveEndDate, setOldEffectiveEndDate] = useState("")
  const [existingAddessFlagState,setExistingAddessFlagState] = useState(false)
  let EffectiveEndDate = props.value?.EffectiveEndDate
  let todaysDate =  moment.utc(new Date()).format("YYYY-MM-DD")

  useEffect(() => {
    setLabel(props.label)
    //setValue(props.value)
    setError(props.error)
  }, [props.label,props.error])

  /**
   * Hadle click on + icon
   */
  const handleClick = () => {
    setOpen(!open)
  }
  
  const handleClickMenu = (event) => {
    changeMode()
    // setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    // setAnchorEl(null);
  };

  useEffect(() => {
    if(props.id ==  'relation'){
      setValue(props.value)
    }
  },[props.value])

  /**
   * handle click of sub list component
   */
  const handleSubClick = () => {
    setOpenList(!openList)
  }

  const handleBrickClick = () => {
    const newState = !brickOpen
    setBrickOpen(newState)
    if (newState && !getBrickObj(props.value)) {
      const emptyBrick = [{
        [CONSTANT.BRICK_FIELDS.BRICK_TYPE]: [{ value: 'BRK', lookupRawValue: 'BRK' }],
        [CONSTANT.BRICK_FIELDS.BRICK_ID]: [{ value: '' }],
        [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE]: [{ value: moment.utc(new Date()).format('YYYY-MM-DD') }],
        [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE]: [{ value: '9999-12-31' }],
        [CONSTANT.BRICK_FIELDS.BRICK_SOURCE]: [{ value: 'LLY-MNGD' }],
      }]
      updateValue(emptyBrick, 'BRICK', true, false)
    }
  }

  // API returns BRICK as a plain object; new-hco state uses BRICK as an array.
  // Resolves to the brick object regardless of which shape is present.
  const getBrickObj = (val) => {
    const raw = val?.BRICK || val?.Brick || val?.brick
    if (!raw) return null
    return Array.isArray(raw) ? raw[0] : raw
  }

  const readBrickField = (brickObj, key) => {
    if (!brickObj) return ''
    // Try direct key, 'Brick' + key (e.g. BrickType), and camelCase variant for 'ID' → 'BrickId'
    const fieldVal = brickObj[key]
      ?? brickObj['Brick' + key]
      ?? (key === 'ID' ? brickObj['BrickId'] : undefined)
    if (fieldVal === undefined || fieldVal === null) return ''
    if (Array.isArray(fieldVal)) return fieldVal[0]?.value || fieldVal[0]?.lookupRawValue || ''
    if (typeof fieldVal === 'object') return fieldVal.value ?? ''
    return typeof fieldVal === 'string' ? fieldVal : ''
  }

  useEffect(() => {
    setBrickOpen(false)
  }, [mode])

  /**
   * Handel Edit mode Change
   */
  const changeMode = () => {
    setEditMode(!editMode)
    if (open === false) {
      setOpen(true)
    }
    if(mode == true){
  //  setHideDeactivationIcon(false)
   props.editMode(!editMode)
    }
    else{
      // setHideDeactivationIcon(false)    
      props.editMode(!editMode)  
    }
    !mode && props.deletePreviousChange()
    !mode && setOldEffectiveEndDate('')
    !mode && setExistingAddessFlagState(false)
    setValue(updatedValue)
    mode && props.EditChange()
    setMode(!mode)
    props.editFlagTrue(!mode)
    handleCloseMenu()
  }

  /**
   * check all addres Attribute
   * @param {*} keys
   * @param {*} arrayValue
   * @returns final flag for adderess
   */
  const checkAllAddressAttribute = (keys, arrayValue) => {
    let flag = false
    if (keys.length === 0) {
      return flag
    } else {
      keys.forEach(key => {
        flag = flag || arrayValue[key]
      })
      return flag
    }
  }
  /**
   * Update DCR values
   * @param {*} Value
   * @param {*} Name
   * @param {*} flag
   * @param {*} arrayFlag
   */
  const updateValue = (Value, Name, flag, arrayFlag) => {
    let todayDate =  moment.utc(new Date()).format("YYYY-MM-DD")
    let AddressChange = CONSTANT.ADDRESS_ATTRIBUTE.includes(Name)
    let oldValue = props.value
    if (AddressChange) {
      let flagsObject = {
        ...updatedValueFlag,
        [Name]: flag
      }
      setUpdatedValueFlag({
        ...updatedValueFlag,
        [Name]: flag
      })
      if(Name == 'ActiveFlag'){
        if(updatedValue.ActiveFlag[0].value !== Value.value){
            setExistingAddessFlagState(!existingAddessFlagState)
        }else{setExistingAddessFlagState(!existingAddessFlagState)}
        if(Value.value != oldValue.ActiveFlag[0].value){
          props.updateValue(
            {
              ...updatedValue,
              [Name]: arrayFlag ? [Value] : Value,
              EffectiveEndDate: [{value: Value.value == 'Y' ? '9999-12-31' : todayDate}],
              IsStatusChanged: true
  
            },
            checkAllAddressAttribute(
              Object.keys(flagsObject),
              flagsObject
            ), 'EffectiveEndDate'
          )      
          deactivateAddress(Value.value) 
        }else{
          props.updateValue(
            {
              ...updatedValue,
              [Name]: oldValue.ActiveFlag,
              EffectiveEndDate: oldValue.EffectiveEndDate,
            },
            checkAllAddressAttribute(
              Object.keys(flagsObject),
              flagsObject
            ), 'EffectiveEndDate'
          )
          undoDeactivation()
        }
       
      }
      else{
        props.updateValue(
          {
            ...value,
            [Name]: arrayFlag ? [Value] : Value
          },
          checkAllAddressAttribute(
            Object.keys(flagsObject),
            flagsObject
          ), Name
        )
        setValue({
          ...value,
          [Name]: arrayFlag ? [Value] : Value
        })

      }
    
    } else {
      props.updateValue(
        {
          ...value,
          [Name]: arrayFlag ? [Value] : Value
        },
        flag, Name
      )
      // if(AddressChange){
      // setValue({
      //   ...value,
      //   [Name]: arrayFlag ? [Value] : Value
      // })
      // }
    }
  }

  const deactivateAddress = (flag) =>{
    let todayDate =  moment.utc(new Date()).format("YYYY-MM-DD")    
    let effectiveEndDate = moment.utc(new Date(props.value?.EffectiveEndDate[0]?.value)).format("YYYY-MM-DD")
       
      if(flag == 'N' && effectiveEndDate < todayDate){
        setOldEffectiveEndDate(`9999-12-31`)
        setValue({...value, EffectiveEndDate:[{value: props.value?.EffectiveEndDate[0]?.value}], ActiveFlag:[{value: flag}]})
      }
      else if(flag == 'N' && effectiveEndDate  > todayDate ){
        setOldEffectiveEndDate(`9999-12-31`)
        setValue({...value, EffectiveEndDate:[{value: todayDate}], ActiveFlag:[{value: flag}]})     
      }
      else {
        setOldEffectiveEndDate(effectiveEndDate < todayDate ? effectiveEndDate : todayDate)
        setValue({...value,  EffectiveEndDate :[{value:`9999-12-31`}], ActiveFlag:[{value: flag}]});       
      }
  }

  const handleSnackbarClose = ()=>{
    setSnackbarOpen(false);
  }

  const undoDeactivation = () =>{
    setValue({...props.value, EffectiveEndDate: EffectiveEndDate});
    setUpdatedValue(props.value)   
    setOldEffectiveEndDate('')
    setExistingAddessFlagState(false)
    props.deletePreviousChange()
  }

  const deleteSepcialty = () =>{
    props.deleteSepcialty()
    setSpecialtyEditFlag(true)
  }

  const undoDeleteSepcialty = () =>{
    props.undoDeleteSepcialty()
    setSpecialtyEditFlag(false)
  }
  return (
    <>
    <List
      component='nav'
      aria-labelledby='nested-list-subheader'
      className={props.accordianLabel === 'Channel Consents' ? 'col-md-6 ': 'col-md-12 p-0 mt-2' }
      style={props.accordianLabel === 'Channel Consents' ? {marginLeft:'1%', marginRight:'1%', paddingLeft:5, paddingRight:5, width:'48%'} : {paddingLeft:5, paddingRight:5, boxShadow:'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px',}}
    >
      <ListItem className={open ? 'bg-dark' : (props.fieldLabelData && props.accordianLabel === 'Channel Consents' ? 'border' : 'bg-dark') }>
        <ListItemText primary={label} sx={{textDecoration:(specialtyEditFlag || props.value?.isDeleted ? 'line-through': 'none')}} />
         {
         props.fieldName == 'Specialities' && props.editSpecialty === 'Edit' && !specialtyEditFlag && value.Source && 
          sourceConfig.ALLOWED_SOURCE_FOR_SPECIALTY_DEACTIVATION.includes(value.Source[0].value) && !props.freezEdit &&
          <Tooltip disableFocusListener title="Delete Specialty" id="tooltip" >    
            <IconButton aria-label="Delete Specialty" className="pointer" color='primary' onClick={()=> deleteSepcialty()}>
              <DeleteIcon className='pointer' />
            </IconButton>         
          </Tooltip> 
        }
        {
          props.fieldName == 'Specialities' && props.editSpecialty === 'Edit' && specialtyEditFlag && value.Source &&
          sourceConfig.ALLOWED_SOURCE_FOR_SPECIALTY_DEACTIVATION.includes(value.Source[0].value) && !props.freezEdit &&
          <Tooltip disableFocusListener title="Undo Delete of Specialty" id="tooltip" >    
            <IconButton aria-label="Undo-delete-specialty" className="pointer" color='primary' onClick={()=>undoDeleteSepcialty()} >
              <ReplayIcon className='pointer' />
            </IconButton>         
          </Tooltip>
        
        }       
        { (props.mode === 'Edit' || props.editAddress == 'Edit') && sourceConfig.ALLOWED_SOURCE_FOR_DEACTIVATION.includes(props.source) &&  props.entity == 'HCO' && props.disableIcon &&
          (<Stack direction="row" spacing={1} sx={{ alignItems: 'center' , marginLeft: 'auto' , display: 'flex', marginRight: '5px' }}>
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open? 'long-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={handleClickMenu}                         
            >
            {!editMode && value['EffectiveEndDate'] && value['EffectiveEndDate'][0].value !== todaysDate ? 
            
            <Edit color='primary' /> : <EditOffIcon color='primary' />  }
              
            </IconButton>

          </Stack>)
        }

        { (props.mode === 'Edit' || props.editAddress == 'Edit') && sourceConfig.EDIT_ADDRESS_SOURCES.includes(props.source) &&  props.entity == 'HCO' && props.disableEditIcons &&
          (<Stack direction="row" spacing={1} sx={{ alignItems: 'center' , marginLeft: 'auto' , display: 'flex', marginRight: '5px' }}>
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open? 'long-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={handleClickMenu}                         
            >
            {editMode ? <EditOffIcon color='primary' /> :<Edit color='primary' /> }
              
            </IconButton>

          </Stack>)
        }

        {open ? (
          <ExpandLess color='action' className='pointer' onClick={handleClick} />
        ) : (
          <ExpandMore color='action' className='pointer' onClick={handleClick} />
        )}
      </ListItem> 
      <Collapse in={open} timeout='auto' unmountOnExit>
        <List component='div' sx={props.fieldLabelData ? { border: 1, borderColor:'#C9C5C4', height:'auto' }:{}} >
          <ListItem className={classes.nested} key={label + 1} >
            {/* if config is not available for details data, then it will use below condition */}
            {!props.fieldLabelData && (
              <ListItemText sx={{textDecoration:(specialtyEditFlag ? 'line-through': 'none')}}
                primary={labelKey?.map((labels, i) => {
                  let passLabel = labels
                  let propertyValue = value[labels]
                  if (labels.length > 3) {
                    labels = labels
                      .replace(/([A-Z])/g, ' $1')
                      .replace(/^./, str => str.toUpperCase())
                  }
                  labels = filter.getLabelName(
                    labels !== undefined ? labels.trim() : labels
                  )
                  if (props.sources !== undefined) {
                    return (
                      <div key={i} id='details-text'>
                        <span className='text-muted mb-2  mt-2'>
                          {labels + ': ' || ''}
                        </span>
                        <span className=' mb-0  mt-2 _wg-exclude'>
                          {propertyValue || ''}
                        </span>
                      </div>
                    )
                  }                  
                  let subObjectFlag = (propertyValue !== undefined && propertyValue.length > 0 ? Object.keys(propertyValue[0])?.includes('value') : false)
                  if (label.toLocaleLowerCase() !== 'ov' && passLabel === 'Address') {
                    return (
                      <div key={i} id='details-text'>
                        {subObjectFlag ? (
                          <SingleValue
                            mode={
                              !mode &&
                                props.mode === 'Edit' &&
                                (props.source !== 'VNDR-CGDM'
                                  ? CONSTANT.HCO_ADDRESS_EDITABLE_EPH.includes(labels)
                                  : CONSTANT.HCO_ADDRESS_EDITABLE_VENDOR.includes(labels)
                                ) &&
                                (props.source === 'VNDR-CGDM' || (value['ActiveFlag'] && value['ActiveFlag'][0].value === 'Y') || labels === 'Active Flag')
                                ? 'Edit'
                                : undefined
                            }
                            existingAddessFlagState={existingAddessFlagState}
                            oldEffectiveEndDate={oldEffectiveEndDate}
                            requiredAddress={(props.source != 'VNDR-CGDM' ? CONSTANT.HCO_ADDRESS_EDITABLE_EPH.includes(labels) : CONSTANT.HCO_ADDRESS_EDITABLE_VENDOR.includes(labels))}
                            key={i}
                            label={labels}
                            value={propertyValue}
                            error={error}
                            entity={props.entity}
                            updatedValue={(value, flag) =>
                              updateValue(value, passLabel, flag, true)
                            }
                          />
                        ) : (
                          <Nested
                            mode={
                              !mode &&
                                props.mode === 'Edit' &&
                                (props.source !== 'VNDR-CGDM'
                                  ? CONSTANT.HCO_ADDRESS_EDITABLE_EPH.includes(labels)
                                  : CONSTANT.HCO_ADDRESS_EDITABLE_VENDOR.includes(labels)
                                ) &&
                                (props.source === 'VNDR-CGDM' || (value['ActiveFlag'] && value['ActiveFlag'][0].value === 'Y') || labels === 'Active Flag')
                                ? 'Edit'
                                : undefined
                            }
                            updatedValue={(value, flag) =>
                              updateValue(value, passLabel, flag, false)
                            }
                            label={labels}
                            error={error}
                            propertyValue={propertyValue}
                            entity={props.entity}
                          />
                        )}
                        {/* Render BRICK if present in address */}
                        {getBrickObj(value) ? (
                          <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid rgba(0,0,0,0.12)' }}>
                            <div id='details-text' style={{ fontWeight: 600, marginBottom: 8 }}>BRICK:</div>
                            {(() => {
                              const brickData = getBrickObj(value);
                              return (
                                <>
                                  <div id='details-text'>
                                    <span className='text-dark'>Brick Type:</span> <span className='text-muted _wg-exclude'>{readBrickField(brickData, CONSTANT.BRICK_FIELDS.BRICK_TYPE)}</span>
                                  </div>
                                  <div id='details-text'>
                                    <span className='text-dark'>Brick Id:</span> <span className='text-muted _wg-exclude'>{readBrickField(brickData, CONSTANT.BRICK_FIELDS.BRICK_ID)}</span>
                                  </div>
                                  <div id='details-text'>
                                    <span className='text-dark'>Brick Effective Start Date:</span> <span className='text-muted _wg-exclude'>{readBrickField(brickData, CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE)}</span>
                                  </div>
                                  <div id='details-text'>
                                    <span className='text-dark'>Brick Effective End Date:</span> <span className='text-muted _wg-exclude'>{readBrickField(brickData, CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE)}</span>
                                  </div>
                                  <div id='details-text'>
                                    <span className='text-dark'>Source:</span> <span className='text-muted _wg-exclude'>{readBrickField(brickData, CONSTANT.BRICK_FIELDS.BRICK_SOURCE)}</span>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        ) : null}
                      </div>
                    )
                  }
                  if (label.toLocaleLowerCase() !== 'ov' && subObjectFlag && passLabel !== 'BRICK') {
                    return (
                      <SingleValue
                        mode={
                          !mode &&
                            props.mode === 'Edit' &&
                            (props.source !== 'VNDR-CGDM'
                              ? CONSTANT.HCO_ADDRESS_EDITABLE_EPH.includes(labels)
                              : CONSTANT.HCO_ADDRESS_EDITABLE_VENDOR.includes(labels)
                            ) &&
                            (props.source === 'VNDR-CGDM' || (value['ActiveFlag'] && value['ActiveFlag'][0].value === 'Y') || labels === 'Active Flag')
                            ? 'Edit'
                            : undefined
                        }
                        existingAddessFlagState={existingAddessFlagState}
                        oldEffectiveEndDate={oldEffectiveEndDate}
                        requiredAddress={(props.source != 'VNDR-CGDM' ? CONSTANT.HCO_ADDRESS_EDITABLE_EPH.includes(labels) : CONSTANT.HCO_ADDRESS_EDITABLE_VENDOR.includes(labels))
                        }
                        key={i}
                        label={labels}
                        value={propertyValue}
                        error={error}
                        entity= {props.entity}
                        source={props.source}
                        updatedValue={(value, flag) =>                           
                          updateValue(value, passLabel, flag, true)
                        }
                      />
                    )
                  }
                  if (label.toLocaleLowerCase() !== 'ov' && !subObjectFlag && labels != 'uri' && labels != 'id' && passLabel !== 'BRICK') {
                    return (
                      <Nested
                        key={i}
                        mode={
                          !mode &&
                            props.mode === 'Edit' &&
                            (props.source !== 'VNDR-CGDM'
                              ? CONSTANT.HCO_ADDRESS_EDITABLE_EPH.includes(labels)
                              : CONSTANT.HCO_ADDRESS_EDITABLE_VENDOR.includes(labels)
                            ) &&
                            (props.source === 'VNDR-CGDM' || (value['ActiveFlag'] && value['ActiveFlag'][0].value === 'Y') || labels === 'Active Flag')
                            ? 'Edit'
                            : undefined
                        }
                        updatedValue={(value, flag) =>
                          updateValue(value, passLabel, flag, false)
                        }
                        label={labels}
                        error={error}
                        propertyValue={propertyValue}
                        entity={props.entity}
                      />
                    )
                  }
                  return ''
                })}
                />
              )}
            </ListItem>

            {/* Brick block — show when data exists (view) OR when editing a Lilly Managed HCO (edit) */}
            {(props.showBrick || (props.entity === 'HCO' && CONSTANT.BRICK_LILLY_MANAGED_SOURCES.includes(props.source))) && (getBrickObj(value) || !mode) && (
              <List>
                <ListItem onClick={handleBrickClick}>
                  <ListItemText primary={'BRICK'} />
                  {brickOpen ? (
                    <ExpandLess className='pointer' />
                  ) : (
                    <ExpandMore className='pointer' />
                  )}
                </ListItem>

                <Collapse in={brickOpen} timeout='auto' unmountOnExit>
                  {(mode || props.mode !== 'Edit') ? (
                    // View mode (profile view + DCR): render BRICK fields using SingleValue — same styling as all other address fields
                    <List component='div'>
                      <ListItem className={classes.nested}>
                        <ListItemText primary={
                          <>
                            {[
                              { id: 'BrickType', name: 'Brick Type', key: CONSTANT.BRICK_FIELDS.BRICK_TYPE },
                              { id: 'BrickId', name: 'Brick Id', key: CONSTANT.BRICK_FIELDS.BRICK_ID },
                              { id: 'BrickEffectiveStartDate', name: 'Brick Effective Start Date', key: CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE },
                              { id: 'BrickEffectiveEndDate', name: 'Brick Effective End Date', key: CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE },
                              { id: 'BrickSource', name: 'Source', key: CONSTANT.BRICK_FIELDS.BRICK_SOURCE },
                            ].map((field) => {
                              const brickVal = readBrickField(getBrickObj(value), field.key)
                              if (!brickVal) return null;
                              return <SingleValue key={field.id} label={field.name} value={[{ value: brickVal }]} />;
                            })}
                          </>
                        } />
                      </ListItem>
                    </List>
                  ) : (
                    // Edit mode only (user clicked the edit icon): form-field layout
                    <div className="row container w-100 p-3 pt-0" style={{ marginLeft: 0 }}>
                      {[
                        { id: 'BrickType', name: 'Brick Type', readOnly: true, date: false },
                        { id: 'BrickId', name: 'Brick Id', readOnly: false, date: false },
                        { id: 'BrickEffectiveStartDate', name: 'Brick Effective Start Date', readOnly: true, date: true },
                        { id: 'BrickEffectiveEndDate', name: 'Brick Effective End Date', readOnly: false, date: true },
                        { id: 'BrickSource', name: 'Source', readOnly: true, date: false },
                      ].map((field, idx) => {
                        const brickFieldKeyMap = {
                          BrickType: CONSTANT.BRICK_FIELDS.BRICK_TYPE,
                          BrickId: CONSTANT.BRICK_FIELDS.BRICK_ID,
                          BrickEffectiveStartDate: CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE,
                          BrickEffectiveEndDate: CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE,
                          BrickSource: CONSTANT.BRICK_FIELDS.BRICK_SOURCE,
                        };
                        const brickKey = brickFieldKeyMap[field.id];
                        let brickValue = readBrickField(getBrickObj(value), brickKey)

                        // Apply defaults when no data exists yet
                        if (field.id === 'BrickType' && !brickValue) brickValue = 'BRK'
                        if (field.id === 'BrickSource' && !brickValue) brickValue = 'LLY-MNGD'
                        if (field.id === 'BrickEffectiveStartDate' && !brickValue) brickValue = moment.utc(new Date()).format('YYYY-MM-DD')
                        if (field.id === 'BrickEffectiveEndDate' && !brickValue) brickValue = '9999-12-31'

                        if (field.date && brickValue) {
                          if (!brickValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
                            brickValue = moment(brickValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
                          }
                        }

                        return (
                          <div key={idx} className="col-sm-12 col-md-6">
                            <span style={{ fontWeight: '500', fontSize: '0.9rem' }}>
                              {field.name}
                              {field.id === 'BrickId' && brickOpen && <span style={{ color: 'red' }}> *</span>}
                            </span>
                            {field.readOnly ? (
                              <div className="w-100">
                                <span
                                  className="text-muted"
                                  style={{
                                    display: 'block',
                                    padding: '6px 0 7px',
                                    borderBottom: '1px solid rgba(0,0,0,0.42)',
                                    minHeight: '32px',
                                  }}
                                >
                                  {brickValue}
                                </span>
                                <div style={{ height: '23px' }} />
                              </div>
                            ) : (
                              <InputDetail
                                date={field.date}
                                type='text'
                                value={brickValue}
                                label={field.name}
                                entity={props.entity}
                                error={field.id === 'BrickId' ? brickOpen : undefined}
                                updatedValue={(newValue, errorFlag) => {
                                  if (field.id === 'BrickEffectiveEndDate') {
                                    const startDate = readBrickField(getBrickObj(value), CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE);
                                    if (startDate && newValue.value && newValue.value < startDate) {
                                      return;
                                    }
                                  }
                                  const existingBrick = getBrickObj(value) || {
                                    [CONSTANT.BRICK_FIELDS.BRICK_TYPE]: [{ value: 'BRK', lookupRawValue: 'BRK' }],
                                    [CONSTANT.BRICK_FIELDS.BRICK_SOURCE]: [{ value: 'LLY-MNGD' }],
                                    [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE]: [{ value: moment.utc(new Date()).format('YYYY-MM-DD') }],
                                    [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE]: [{ value: '9999-12-31' }],
                                  };
                                  const updatedBrick = [{
                                    ...existingBrick,
                                    [brickKey]: [newValue]
                                  }];
                                  const brickError = field.id === 'BrickId' ? (brickOpen && !!errorFlag) : false;
                                  updateValue(updatedBrick, 'BRICK', brickError, false);
                                }}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </Collapse>
              </List>
            )}
          <ListItem className={classes.nested}>
            {/* if config is available for details (consents), then it will use below condition */}
            {props.fieldLabelData && (
              <ListItemText>
                {props.fieldLabelData?.fields?.map((val, i) => {
                  let passLabel = val.label
                  let propertyValue = value[val.key]

                  if (typeof propertyValue != 'object') {
                    if (props.sources !== undefined) {
                      return (
                        <div key={i} id='details-text'>
                          <span className='text-muted'>
                            {passLabel + ': ' || ''}
                          </span>
                          
                          <span className=' mb-0 _wg-exclude'>
                            {
                              passLabel === 'Privacy Notice' && propertyValue !== 'None'  ? 
                              <CustomWidthTooltip PopperProps={{style:{zIndex:9001}}} style={{maxWidth: 700}} title={propertyValue}><IconButton onClick={()=> window.open(propertyValue,'_blank')}> <LinkIcon/></IconButton></CustomWidthTooltip>
                              : (propertyValue ? propertyValue : '')
                            }
                            
                          </span>
                        </div>
                      )
                    }
                  } else {                    
                    return (
                      <React.Fragment key={i}>
                        <List
                          component='nav'
                          aria-labelledby='nested-list-subheader'
                          className={'border p-0 mt-2'}
                          
                        >
                          <ListItem className={"bg-muted"}>
                            <ListItemText primary={passLabel} />
                            {openList ? (
                              <Remove
                                className='pointer'
                                onClick={handleSubClick}
                              />
                            ) : (
                              <Add className='pointer' onClick={handleSubClick} />
                            )}
                          </ListItem>
                          <Collapse in={openList} timeout='auto' unmountOnExit>
                            <List component='div'>
                            <ListItem className={classes.nested}>
                              <ListItemText
                                primary={propertyValue?.map((attri, key) => { 
                                  if(Object.keys(attri).length > 0)
                                  {
                                  return (
                                    <React.Fragment key={key}>                                      
                                      {val?.fields?.map((el, index) => {
                                        let nestedvalue = attri[el.key]                                        
                                          return (
                                            <div key={index} id='details-text'>
                                              <span className='text-muted'>
                                                {el.label + ': ' || ''}
                                              </span>
                                              <span className=' mb-0 _wg-exclude'>
                                                {nestedvalue || ''}
                                              </span>
                                            </div>
                                          )
                                          })}
                                    </React.Fragment>                       
                                  )
                                  }
                                  else{
                                    return(
                                      <div key={key} id='details-text'>                                             
                                        <span className='_wg-dynamic-text'>
                                        <em>No data found</em>
                                        </span>
                                      </div>
                                    )
                                  }
                                })}
                              />
                            </ListItem>
                            </List>
                          </Collapse>
                        </List>
                      </React.Fragment>
                    )
                  }
                  return''
                })}
              </ListItemText>
            )}
          </ListItem>
        </List>
      </Collapse>
    </List>

    <SnackBarComponent snackbarOpen ={snackbarOpen}  handleSnackbarClose={handleSnackbarClose} snackBarMessage={snackBarMessage}/>
    </>
  )
}
export default ListView
